import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-messagecentercontainer',
  templateUrl: './messagecentercontainer.component.html',
  styleUrls: ['./messagecentercontainer.component.css']
})
export class MessagecentercontainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/dash-board/messagecenter/messagecentercontainer/messagecentercontainer.component.ts